var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Pane, Button, Row, Col, AccordionSet, Accordion, PaneFooter, ErrorModal, Checkbox, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, Controller, useFieldArray, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RecekTextField, RecekSelect } from "../../components/inputs";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createNaturalPersonSchema } from "../../utils/validationUtils";
import { useModal } from "../../utils/useModal";
import { buildPersonInvalidSubmitContent } from "../../utils/personInvalidSubmit";
import { useAccordion } from "../../utils/useAccordion";
import { PersonIdentifierTypeEnum } from "../../types/Api";
import { FormFooterStart } from "../../components/FormFooterStart";
import { FormFooterEnd } from "../../components/FormFooterEnd";
import { NaturalPersonGeneralFields } from "../../components/NaturalPersonGeneralFields";
import { LocalOnlyCheckbox } from "../../components/LocalOnlyCheckbox";
import { useScrollToError } from "../../hooks/useScrollToError";
var NaturalPersonForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title;
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var _b = useModal(), isOpen = _b.isOpen, message = _b.message, openModal = _b.openModal, closeModal = _b.closeModal;
    var _c = useAccordion({
        identifiers: true,
        alternativeNames: true,
    }), accordionStatus = _c.accordionStatus, toggleAccordion = _c.toggleAccordion;
    var _d = useForm({
        resolver: zodResolver(createNaturalPersonSchema(formatMessage)),
        defaultValues: initialValues,
        mode: "onBlur",
    }), handleSubmit = _d.handleSubmit, control = _d.control, reset = _d.reset, watch = _d.watch, errors = _d.formState.errors;
    useScrollToError(errors);
    var watchedDeathDate = watch("deathDate");
    var watchedLocalOnly = watch("localOnly");
    // The local-only choice is offered on create only; the backend ignores it on update.
    var isCreate = !initialValues.id;
    var _e = useFieldArray({
        control: control,
        name: "naturalAlternativeNames",
    }), alternativeNameFields = _e.fields, appendAlternativeName = _e.append, removeAlternativeName = _e.remove;
    var _f = useFieldArray({
        control: control,
        name: "identifiers",
    }), identifierFields = _f.fields, appendIdentifier = _f.append, removeIdentifier = _f.remove;
    useEffect(function () {
        reset(initialValues);
    }, [initialValues, reset]);
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onSubmit(__assign(__assign({}, initialValues), data))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    errorMessage = initialValues.id
                        ? "ui-br-agency.natural-person.error.update"
                        : "ui-br-agency.natural-person.error.submit";
                    openModal(formatMessage({ id: errorMessage }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleInvalidSubmit = function (formErrors) {
        openModal(buildPersonInvalidSubmitContent(formatMessage, formErrors));
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, onInvalid: handleInvalidSubmit, buttonMessageId: "ui-br-agency.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: function () {
                        return navigation.naturalPersons &&
                            history.push(navigation.naturalPersons.path);
                    }, buttonMessageId: "ui-br-agency.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: isOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: message, onClose: closeModal }),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(function (data) {
                    return handleFormSubmit(__assign(__assign({}, initialValues), data));
                }, handleInvalidSubmit) },
                React.createElement(NaturalPersonGeneralFields, { control: control, biographicalNoteRequired: !watchedLocalOnly }),
                !watchedDeathDate && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Controller, { control: control, name: "disclosureConsent", render: function (_a) {
                                var _b;
                                var _c = _a.field, value = _c.value, onChange = _c.onChange, fieldState = _a.fieldState;
                                return (React.createElement(Checkbox, { label: formatMessage({
                                        id: "ui-br-agency.natural-person.disclosureConsent.field.label",
                                    }), checked: !!value, onChange: function (e) { return onChange(e.target.checked); }, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }));
                            } })))),
                isCreate && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(LocalOnlyCheckbox, { control: control })))),
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-agency.natural-person.accordions.label.identifiers",
                        }), open: accordionStatus.identifiers, onToggle: function () { return toggleAccordion("identifiers"); } },
                        identifierFields.map(function (identifierField, index) { return (React.createElement(Row, { key: identifierField.id, style: { marginBottom: "15px" } },
                            React.createElement(Col, { xs: 12, md: 5 },
                                React.createElement(Controller, { control: control, name: "identifiers.".concat(index, ".type"), render: function (_a) {
                                        var _b;
                                        var field = _a.field, fieldState = _a.fieldState;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-agency.natural-person.identifier.type.field.label", dataOptions: [
                                                {
                                                    value: PersonIdentifierTypeEnum.ISNI,
                                                    label: formatMessage({
                                                        id: "ui-br-agency.natural-person.identifier.type.isni",
                                                    }) || "ISNI",
                                                },
                                                {
                                                    value: PersonIdentifierTypeEnum.ORCID,
                                                    label: formatMessage({
                                                        id: "ui-br-agency.natural-person.identifier.type.orcid",
                                                    }) || "ORCID",
                                                },
                                            ], error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 5 },
                                React.createElement(Controller, { control: control, name: "identifiers.".concat(index, ".identifier"), render: function (_a) {
                                        var _b;
                                        var field = _a.field, fieldState = _a.fieldState;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.identifier.value.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 2, style: { display: "flex", alignItems: "flex-end" } },
                                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeIdentifier(index); }, style: { marginBottom: "15px" } },
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" }))))); }),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { onClick: function () {
                                        return appendIdentifier({
                                            type: PersonIdentifierTypeEnum.ISNI,
                                            identifier: "",
                                        }, { shouldFocus: false });
                                    } },
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.button.addIdentifier" }))))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-agency.natural-person.accordions.label.alternativeNames",
                        }), open: accordionStatus.alternativeNames, onToggle: function () { return toggleAccordion("alternativeNames"); } },
                        alternativeNameFields.map(function (field, index) { return (React.createElement(Row, { key: field.id, style: { marginBottom: "15px" } },
                            React.createElement(Col, { xs: 12, md: 5 },
                                React.createElement(Controller, { control: control, name: "naturalAlternativeNames.".concat(index, ".firstName"), render: function (_a) {
                                        var _b;
                                        var field = _a.field, fieldState = _a.fieldState;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.alternativeName.firstName.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 5 },
                                React.createElement(Controller, { control: control, name: "naturalAlternativeNames.".concat(index, ".lastName"), render: function (_a) {
                                        var _b;
                                        var field = _a.field, fieldState = _a.fieldState;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.alternativeName.lastName.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 2, style: { display: "flex", alignItems: "flex-end" } },
                                React.createElement(Button, { buttonStyle: "danger", onClick: function () { return removeAlternativeName(index); }, style: { marginBottom: "15px" } },
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" }))))); }),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Button, { onClick: function () {
                                        return appendAlternativeName({ firstName: "", lastName: "" });
                                    } },
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.natural-person.button.addAlternativeName" }))))))))));
};
export default NaturalPersonForm;
